import React, { Component } from 'react'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'
import Typography from '../UI/Typography'
import Button from '../UI/Button'
import { device, doveItems } from '../../utils/helpers'
import CheckMarkIcon from '../UI/Icons/CheckMarkIcon.js'
import CrossIcon from '../UI/Icons/CrossIcon.js'

// Features
const Wrapper = styled.div`
  margin-top: 80px;

  @media ${device.tablet} {
    margin-top: 120px;
  }
`

const Section = styled.section`
  background: ${props => props.grey ? props.theme.color.bgLight : '#fff'};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

const InfoSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: left;
  background: #f3f3f3;
  padding: 4rem 0;

  @media ${device.laptop} {
    padding: 7rem 0;
  }
`

const Title = styled.div`
  padding: 3.6rem 1.5rem;
  text-align: center;
`

const BigTitle = styled.div`
  padding: 4.5rem 3rem 0 3rem;
  text-align: center;

  @media ${device.laptop} {
    padding: 4.5rem 2rem 0 2rem;
    width: 95%;
  }

  @media ${device.desktop} {
    width: 95%;
  }
`

const Info = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  padding-bottom: 30px;
  width: 90%;

  @media ${device.laptop} {
    width: 65%;
    padding-bottom: 40px;
  }

  @media ${device.desktop} {
    width: 65%;
    padding-bottom: 40px;
  }
`

const ButtonWrapper = styled.div`
  padding: 4.5rem 0;

  @media ${device.tablet} {
    padding: 2.5rem 1.5rem;
  }

  @media ${device.laptop} {
    padding-bottom: 4rem;
  }
`

const Table = styled.table`
  border: 1px solid black;
  width: 100%;
`

const TableRow = styled.tr`
  border: 1px solid black;
`

const TableData = styled.td`
  border: 1px solid black;
  padding: 5px;

  &:nth-child(2) {
    text-align: center;
  }
`

const Checkmark = styled(CheckMarkIcon)`
  ${''/* width: 10px; */}
  width: 15px;
`

const Cross = styled(CrossIcon)`
  ${''/* width: 10px; */}
  width: 10px;
`

const TableCol = styled.div`
  width: 100%;
  padding-bottom: 20px;

  @media ${device.tablet} {
    width: 31%;
  }
`

const Tables = styled.div`
  display: flex;
  flex-direction: column;

  @media ${device.tablet} {
    flex-direction: row;
    justify-content: space-between;
  }
`

class DoveNoleggiamo extends Component {
  render () {
    return (
      <Wrapper>
        <Helmet>
          <title>Dove noleggiamo Noleggiocampi.it</title>
          <meta name='Description' content='Pagina di supporto dove è disponibile lelenco delle città e province dove è possibile richiedere il noleggio' />
          <meta name='Keywords' content='campi smontabili,noleggio attrezzature sportive,noleggio impianti sportivi mobili' />
          <meta name='robots' content='noindex, nofollow' />
        </Helmet>
        <Title>
          <Typography variant='h1' type='title'>DOVE NOLEGGIAMO</Typography>
        </Title>
        <InfoSection>
          <Info>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Ecco l’elenco completo dei comuni in cui effettuiamo il noleggio:
            </Typography>
            <Tables>
              <TableCol>
                <Table>
                  {doveItems.map((item, index) => {
                    if (index < 37) {
                      return (
                        <TableRow>
                          <TableData>{item.name}</TableData>
                          <TableData>{item.status === 'yes' ? <Checkmark fill='#4d4d4d' /> : <Cross fill='#4d4d4d' />}</TableData>
                        </TableRow>
                      )
                    }
                  })}
                </Table>
              </TableCol>
              <TableCol>
                <Table>
                  {doveItems.map((item, index) => {
                    if (index > 36 && index < 74) {
                      return (
                        <TableRow>
                          <TableData>{item.name}</TableData>
                          <TableData>{item.status === 'yes' ? <Checkmark fill='#4d4d4d' /> : <Cross fill='#4d4d4d' />}</TableData>
                        </TableRow>
                      )
                    }
                  })}
                </Table>
              </TableCol>
              <TableCol>
                <Table>
                  {doveItems.map((item, index) => {
                    if (index > 73) {
                      return (
                        <TableRow>
                          <TableData>{item.name}</TableData>
                          <TableData>{item.status === 'yes' ? <Checkmark fill='#4d4d4d' /> : <Cross fill='#4d4d4d' />}</TableData>
                        </TableRow>
                      )
                    }
                  })}
                </Table>
              </TableCol>
            </Tables>
          </Info>
        </InfoSection>
        <Section>
          <BigTitle>
            <Typography variant='h2' type='title'>
              IL TUO COMUNE NON È FRA QUELLI SELEZIONATI?<br />
              NON DISPERARE, CONTATTACI E UN NOSTRO CONSULENTE VERIFICHERÀ<br />
              LA POSSIBILITÀ DI NOLEGGIO NELLA TUA ZONA!
            </Typography>
          </BigTitle>
          <ButtonWrapper>
            <Button secondary to='/contattaci'>CONTATTACI</Button>
          </ButtonWrapper>
        </Section>
      </Wrapper>
    )
  }
}

export default DoveNoleggiamo



// WEBPACK FOOTER //
// ./src/components/Pages/Dove.js